// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconContainer[data-v-8da728be]:hover {\n  color: white;\n}\n.iconContainer:hover svg[data-v-8da728be] {\n  --text-opacity: 1;\n  color: #1A7BEE;\n  color: rgba(26, 123, 238, var(--text-opacity));\n  fill: white;\n}", ""]);
// Exports
module.exports = exports;
